var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDev)?_c('div',{staticClass:"bar-container"},[_vm._v(" !!! Dev környezet !!! ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }